 const  HeaderNavigate = [
    {
        name: "Home",
        id: 0,
        url: "/",
    },
    {
        name: "About Us",
        id: 1,
        url: "/aboutus",
    },
    {
        name: "Resume",
        id: 2,
        url: "/resume",
    },
    {
        name: "Project",
        id: 3,
        url: "/project",
    },
    {
        name: "Contact Us",
        id: 4,
        url: "/contactus",
    },
    {
        name: "Coding Profile",
        id: 5,
        url: "/codingprofile",
    }
];
export default HeaderNavigate;

